import { render, staticRenderFns } from "./UnknownExtension.vue?vue&type=template&id=7df0c65f"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7df0c65f')) {
      api.createRecord('7df0c65f', component.options)
    } else {
      api.reload('7df0c65f', component.options)
    }
    module.hot.accept("./UnknownExtension.vue?vue&type=template&id=7df0c65f", function () {
      api.rerender('7df0c65f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/fileExtensions/UnknownExtension.vue"
export default component.exports